import { useMemo } from "react";
import { moneyFormatter } from "../../shared/money";
import { useCompany } from "./company";

/** Money formatting for the business being viewed (its currency and region from ServiceM8). */
export function useMoney() {
    const { money } = useCompany();
    return useMemo(() => moneyFormatter(money), [money]);
}
